export const categories = [
  { id: 1, name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { id: 2, name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { id: 3, name: '动漫', slug: 'anime', icon: 'ri-emotion-line' },
  { id: 4, name: '综艺', slug: 'variety', icon: 'ri-live-line' },
];

export const featuredMovies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    year: 2026,
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨型推进器，开启长达2500年的星际流浪之旅。第三部将揭示人类最终命运，全新视觉盛宴震撼来袭。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20giant%20planet%20engines%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20orange%20and%20gold%20accents%2C%20professional%20movie%20poster%20style%2C%20clean%20minimal%20design&width=400&height=600&seq=featured-01&orientation=portrait',
    tags: ['科幻', '冒险', '国产'],
    duration: '148分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
  },
  {
    id: 2,
    title: '深海奇缘',
    category: 'anime',
    year: 2026,
    rating: 8.9,
    description: '一个少女在神秘海底世界的奇幻冒险。她遇到各种奇特海洋生物，揭开深海隐藏的秘密。国产动画巅峰之作，画面美轮美奂。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animated%20film%20poster%20with%20a%20young%20girl%20in%20magical%20underwater%20world%2C%20colorful%20coral%20reefs%20and%20glowing%20jellyfish%2C%20dreamy%20atmosphere%2C%20soft%20lighting%2C%20cinematic%20animation%20style%2C%20dark%20background%20with%20teal%20and%20coral%20accents&width=400&height=600&seq=featured-02&orientation=portrait',
    tags: ['动画', '奇幻', '冒险'],
    duration: '112分钟',
    director: '田晓鹏',
    actors: ['张子枫', '陈坤', '周迅'],
  },
  {
    id: 3,
    title: '长安十二时辰',
    category: 'tv',
    year: 2026,
    rating: 9.5,
    description: '唐朝天宝三年，上元节前夕，长安城混入可疑狼卫。死囚张小敬临危受命，与李必携手在十二时辰内破除阴谋，拯救长安城。',
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20set%20in%20ancient%20Tang%20Dynasty%20Changan%20city%2C%20warrior%20in%20traditional%20armor%20with%20lantern-lit%20streets%20at%20night%2C%20epic%20cinematic%20style%2C%20warm%20golden%20and%20red%20tones%2C%20dramatic%20composition&width=400&height=600&seq=featured-03&orientation=portrait',
    tags: ['古装', '悬疑', '历史'],
    duration: '48集',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围'],
  },
  {
    id: 4,
    title: '极限挑战·巅峰季',
    category: 'variety',
    year: 2026,
    rating: 8.7,
    description: '国内最受欢迎户外真人秀节目全新一季。明星嘉宾挑战极限任务，爆笑不断，温情满满。全新阵容带来全新化学反应。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20doing%20outdoor%20challenges%2C%20bright%20and%20energetic%20style%2C%20colorful%20design%20with%20sports%20elements%2C%20professional%20entertainment%20poster%2C%20vibrant%20warm%20colors&width=400&height=600&seq=featured-04&orientation=portrait',
    tags: ['真人秀', '搞笑', '挑战'],
    duration: '12期',
    director: '',
    actors: ['黄渤', '孙红雷', '黄磊', '张艺兴'],
  },
  {
    id: 5,
    title: '暗夜追踪',
    category: 'movie',
    year: 2026,
    rating: 8.5,
    description: '一名刑警在追踪连环案件过程中，发现背后隐藏的惊天秘密。紧张刺激的犯罪悬疑大片，反转不断让人欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20movie%20poster%20with%20detective%20in%20dark%20rainy%20city%20alley%2C%20noir%20style%2C%20dramatic%20shadows%20and%20neon%20lights%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background%20with%20red%20accents&width=400&height=600&seq=featured-05&orientation=portrait',
    tags: ['犯罪', '悬疑', '剧情'],
    duration: '126分钟',
    director: '曹保平',
    actors: ['段奕宏', '周迅', '黄轩'],
  },
  {
    id: 6,
    title: '天道图书馆',
    category: 'anime',
    year: 2026,
    rating: 9.0,
    description: '改编自同名热门小说。普通图书管理员张悬穿越异世界，凭借脑海中的天道图书馆，成为无所不知的师者，开创传奇人生。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20young%20male%20protagonist%20holding%20a%20glowing%20ancient%20book%20in%20a%20fantasy%20world%2C%20magical%20energy%20surrounding%2C%20epic%20atmosphere%2C%20anime%20art%20style%2C%20golden%20and%20crimson%20color%20scheme&width=400&height=600&seq=featured-06&orientation=portrait',
    tags: ['奇幻', '热血', '穿越'],
    duration: '52集',
    director: '',
    actors: [],
  },
];

export const latestUpdates = [
  { id: 7, title: '庆余年·第二季', category: 'tv', year: 2026, rating: 9.4, episode: '更新至36集', image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20handsome%20male%20lead%20in%20traditional%20robe%20holding%20sword%2C%20palace%20background%2C%20epic%20cinematic%20style%2C%20warm%20golden%20tones%2C%20professional%20drama%20poster&width=400&height=600&seq=latest-01&orientation=portrait', tags: ['古装', '权谋'] },
  { id: 8, title: '星际穿越2：重生', category: 'movie', year: 2026, rating: 8.8, episode: 'HD高清', image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20spaceship%20flying%20through%20wormhole%2C%20cosmic%20phenomena%2C%20dramatic%20lighting%2C%20epic%20space%20adventure%2C%20dark%20background%20with%20blue%20and%20white%20nebula%2C%20cinematic%20poster%20style&width=400&height=600&seq=latest-02&orientation=portrait', tags: ['科幻', '冒险'] },
  { id: 9, title: '斗罗大陆·终极之战', category: 'anime', year: 2026, rating: 9.1, episode: '更新至128集', image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20young%20warrior%20in%20fantasy%20armor%20summoning%20spirit%20rings%2C%20epic%20battle%20scene%2C%20vibrant%20energy%20effects%2C%20dramatic%20fantasy%20art%20style%2C%20golden%20and%20azure%20colors&width=400&height=600&seq=latest-03&orientation=portrait', tags: ['热血', '玄幻'] },
  { id: 10, title: '王牌对王牌·第九季', category: 'variety', year: 2026, rating: 8.6, episode: '更新至08期', image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20playing%20fun%20games%20on%20stage%2C%20bright%20colorful%20studio%20lights%2C%20energetic%20and%20entertaining%20atmosphere%2C%20professional%20show%20poster%2C%20warm%20vibrant%20colors&width=400&height=600&seq=latest-04&orientation=portrait', tags: ['综艺', '搞笑'] },
  { id: 11, title: '封神·第二部', category: 'movie', year: 2026, rating: 8.9, episode: 'HD高清', image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20gods%20and%20warriors%20in%20epic%20battle%2C%20thunder%20and%20lightning%20effects%2C%20dramatic%20Chinese%20mythology%20style%2C%20golden%20and%20crimson%20color%20palette&width=400&height=600&seq=latest-05&orientation=portrait', tags: ['神话', '奇幻'] },
  { id: 12, title: '狂飙·续', category: 'tv', year: 2026, rating: 9.3, episode: '更新至24集', image: 'https://readdy.ai/api/search-image?query=Crime%20drama%20Chinese%20TV%20series%20poster%20with%20two%20men%20in%20tense%20standoff%2C%20urban%20night%20cityscape%20background%2C%20gritty%20realistic%20style%2C%20dark%20moody%20atmosphere%2C%20professional%20drama%20poster&width=400&height=600&seq=latest-06&orientation=portrait', tags: ['犯罪', '剧情'] },
  { id: 13, title: '白蛇·缘起3', category: 'anime', year: 2026, rating: 8.7, episode: 'HD高清', image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20romance%20fantasy%20poster%20with%20beautiful%20woman%20in%20white%20traditional%20dress%20and%20young%20man%2C%20floating%20peach%20blossoms%2C%20ethereal%20atmosphere%2C%20poetic%20Chinese%20animation%20style%2C%20soft%20pink%20and%20white%20tones&width=400&height=600&seq=latest-07&orientation=portrait', tags: ['爱情', '奇幻'] },
  { id: 14, title: '奔跑吧·生态篇', category: 'variety', year: 2026, rating: 8.4, episode: '更新至06期', image: 'https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20variety%20show%20poster%20with%20celebrities%20running%20in%20nature%2C%20green%20landscape%20background%2C%20fun%20and%20energetic%20vibe%2C%20professional%20entertainment%20poster%2C%20bright%20natural%20colors&width=400&height=600&seq=latest-08&orientation=portrait', tags: ['户外', '竞技'] },
];

export const allMovies = [...featuredMovies, ...latestUpdates];

export const moviesByCategory = {
  movie: allMovies.filter((m) => m.category === 'movie'),
  tv: allMovies.filter((m) => m.category === 'tv'),
  anime: allMovies.filter((m) => m.category === 'anime'),
  variety: allMovies.filter((m) => m.category === 'variety'),
};

export const reviews = [
  { id: 1, name: '影迷小王', rating: 5, content: '资源太全了！想看的电影电视剧基本都能找到，画质也很清晰，不愧是屁屁影院！每天必刷的网站。', date: '2026-08-05' },
  { id: 2, name: '追剧达人', rating: 5, content: '更新速度超快，很多新剧当天就能看到。播放流畅不卡顿，强烈推荐给所有爱追剧的朋友！', date: '2026-08-03' },
  { id: 3, name: '动漫宅', rating: 5, content: '动漫资源非常多，国漫日漫都有，而且分类清晰查找方便。终于不用到处找资源了，一个屁屁影院全搞定。', date: '2026-08-01' },
  { id: 4, name: '电影发烧友', rating: 4, content: '高清片源很赞，在家也能享受影院级观影体验。如果能有更多4K资源就更完美了，期待继续更新！', date: '2026-07-28' },
  { id: 5, name: '周末影迷', rating: 5, content: '每周都会上来看看有什么新片，推荐算法很精准，推荐的都是我喜欢的类型。真心好评！', date: '2026-07-25' },
  { id: 6, name: '剧荒拯救者', rating: 5, content: '分类做得很好，不知道看什么的时候逛逛分类就能找到好剧。收藏功能也很方便，追剧神器！', date: '2026-07-20' },
];

export const faqs = [
  { q: '屁屁影院需要注册才能观看吗？', a: '完全不需要！屁屁影院坚持免费开放，所有影视资源无需注册、无需登录即可直接观看，真正做到即点即看。' },
  { q: '屁屁影院的资源更新频率如何？', a: '我们每天都会更新最新影视内容，热门电影、电视剧、动漫、综艺同步上线，确保您不会错过任何精彩内容。' },
  { q: '在屁屁影院观看视频卡顿怎么办？', a: '我们提供多条播放线路，如果当前线路卡顿，可以尝试切换其他线路。建议在网络环境良好的情况下选择高清画质以获得最佳观影体验。' },
  { q: '屁屁影院支持哪些设备观看？', a: '屁屁影院全面支持电脑、平板、手机等多种设备，无需安装任何APP，打开浏览器即可畅享高清影视内容。' },
  { q: '可以在屁屁影院下载视频吗？', a: '屁屁影院为在线观看平台，暂不提供下载功能。但我们支持随时随地在线观看，只要有网络就能享受流畅的观影体验。' },
];